class Dropdown {
    dropdown: Element;
    dropdownButton: Element | null;
    dropdownContainer: Element | null;

    constructor(dropdown: Element) {
        this.dropdown = dropdown;

        this.dropdownButton = dropdown.querySelector('.dropdown-button');
        this.dropdownContainer = dropdown.querySelector('.dropdown-container');

        if (this.dropdownButton) {
            this.dropdownButton.addEventListener('click', (event) => {
                event.stopPropagation();
                this.dropdownContainer?.classList.toggle('hidden');
                this.dropdownButton?.classList.toggle('active');
                this.dropdownButton?.querySelector('svg')?.classList.toggle('rotate-180');
            });

            window.addEventListener('click', () => {
                if (this.dropdownContainer?.classList.contains('hidden')) return;
                this.dropdownContainer?.classList.add('hidden');
                this.dropdownButton?.classList.toggle('active');
                this.dropdownButton?.querySelector('svg')?.classList.toggle('rotate-180');
            });
        }
    }
}

export default {
    init() {
        const dropdown = document.querySelectorAll('.dropdown') as NodeListOf<Element>;

        if (!dropdown.length) {
            return;
        }

        dropdown.forEach((dropdown) => {
            new Dropdown(dropdown);
        });
    }
};
